<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="85"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
        <el-form-item
            class="el_from select_down"
            label="商品名称"
            slot="productId"
            style="margin:0"
        >
            <el-select
                :popper-append-to-body="false"
                v-model="productId"
                placeholder="请选择"
                clearable
                filterable
            >
            <el-option
                v-for="item in productList"
                 :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item
            class="el_from select_down"
            label="所属分类"
            slot="typeCode"
            style="margin:0"
        >
            <el-select
                :popper-append-to-body="false"
                v-model="typeCode"
                placeholder="请选择"
                clearable
            >
            <el-option
                v-for="item in machineType"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
        </el-form-item>
    </GlobalForm>
  </div>
</template>

<script>
import { formValidateMobile } from "@/utils/form-validate";
import moment from "moment";
import _api from "@/utils/request";
export default {
    name: "Form",
    props: {
        machineType: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            typeCode: "",
            productId:"",
            productList:[],
            initData: { entryTime: [moment().day(moment().day() - 180).format("YYYY-MM-DD 00:00:00"),
                        moment().format("YYYY-MM-DD 23:59:59")]},
            entryTime: {
                entryTime: [ moment().day(moment().day() - 6).format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")]
            },
            startTime: "",
            endTime: "",
            pickerMinDate: null,
            pickerMaxDate: null,
            day31: 180 * 24 * 3600 * 1000,
            formItemList: [
                { slotName: "productId" }, //商品名称
                { slotName: "typeCode" }, //所属分类
                {
                    key: "entryTime",
                    type: "pickerOptions",
                    labelName: "时间",
                    lableWidth: "54px",
                    placeholder: "请选择时间",
                    valueFormat: "timestamp",
                    clearable:true,
                    pickerOptions: {
                        onPick: ({ maxDate, minDate }) => {
                        if (minDate && this.pickerMinDate) {
                            this.pickerMinDate = null;
                        } else if (minDate) {
                            this.pickerMinDate = minDate.getTime();
                        }
                        },
                        disabledDate: (time) => {
                        if (this.pickerMinDate) {
                            return (
                            time.getTime() > this.pickerMinDate + this.day31 ||
                            time.getTime() < this.pickerMinDate - this.day31
                            );
                        }
                        return false;
                        },
                    },
                },
            ],
            formRules: {
                mobile: [
                    {
                        validator: formValidateMobile,
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.productSelect();
        this.handleConfirm(this.initData)
    },
    methods: {
        //商品下拉
        productSelect(){
            _api.productSelect().then((res) => {
                this.productList = res.data;
            });   
        },
        //查询
        handleConfirm(data,cd) {
            let startTime = "";
            let endTime = "";
            if (data.entryTime === null) {
            (startTime = ""), (endTime = "");
            } else {
                (startTime = Number(moment(data.entryTime[0]).format("x")) ),
                (endTime = Number(moment(data.entryTime[1]).format("x")));
            }
            const baseRequest = {
                productId: this.productId,  
                typeCode: this.typeCode,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                disuseLoding: () => {
                    if (typeof cd === 'function') {
                    cd()
                    }
                },
            };
            this.$store.commit("tagsView/SEACH_PARAMS", baseRequest);
        },
    },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
  /deep/.el-select-dropdown {
    border-radius: 20px;
  }
  .select_down {
    /deep/.el-popper {
      border-radius: 20px;
    }
    /deep/.el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #e4ecfd;
      color: rgba(9, 129, 255, 1);
    }
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .time-type{
    /deep/.el-input__inner{
      border: none;
    }
  }
}
</style>
